import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type PortalBuilderFlatTeamSettingGroupId = "portal_builder.overview";

const portalbuilderOwner: SettingOwner = {
  kind: "teamSettings",
  product: "returns",
};

const portalbuilderRisk: SettingRisk = {
  level: "medium",
  reason: "Portal builder controls the customer-facing portal layout.",
};

export const PortalBuilderFlatTeamSettingGroups = [
  {
    id: "portal_builder.overview",
    title: "Portal builder",
    description: "Visual builder for the customer portal layout.",
    productArea: "returns",
    access: directMerchantAccess(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    ),
    owner: portalbuilderOwner,
    risk: portalbuilderRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "portal-builder" },
    synonyms: ["portal builder", "portal layout", "customer portal builder"],
  },
] as const satisfies readonly SettingGroupDefinition<PortalBuilderFlatTeamSettingGroupId>[];

type _assertAllPortalBuilderFlatTeamSettingGroupsProvided =
  PortalBuilderFlatTeamSettingGroupId extends (typeof PortalBuilderFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allPortalBuilderFlatTeamSettingGroupsProvided: _assertAllPortalBuilderFlatTeamSettingGroupsProvided = true;
void _allPortalBuilderFlatTeamSettingGroupsProvided;

export const PortalBuilderFlatTeamSettingGroupById: Record<
  PortalBuilderFlatTeamSettingGroupId,
  SettingGroupDefinition<PortalBuilderFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      PortalBuilderFlatTeamSettingGroupId,
      SettingGroupDefinition<PortalBuilderFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of PortalBuilderFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return map as Record<
    PortalBuilderFlatTeamSettingGroupId,
    SettingGroupDefinition<PortalBuilderFlatTeamSettingGroupId>
  >;
})();
